import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
`;

export const Key = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 1.6rem;
  height: 1.6rem;
  padding: 0 ${({ theme }) => theme.spacing(0.5)};

  border-radius: ${({ theme }) => theme.spacing(1)};
  background: ${({ theme }) => theme.palette.grey[300]};
  color: ${({ theme }) => theme.palette.text.secondary};
`;
